import type { JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@mui/material/Button";

import { useSubstructureStandaloneContentCtx } from "@/renderer/SubstructureStandaloneContentCtx";

export function FinishConfigurationButton(): JSX.Element {
  const { t } = useTranslation();
  const { setSelectedSubstructure } = useSubstructureStandaloneContentCtx();
  return (
    <Button onClick={() => setSelectedSubstructure(null)}>
      {t("regiolux:button.finishConfiguration.label")}
    </Button>
  );
}
